import React, { useState, useEffect } from 'react';
import './Leaderboard.css';

const Leaderboard = ({ score, onRestart, onGoHome }) => {
  const [elements, setElements] = useState([]);
  const [erreur, setErreur] = useState(null);
  const [name, setName] = useState('');
  const [email, setEmail] = useState('');
  const [submitted, setSubmitted] = useState(false);
  
  const estInterne = email.toLowerCase().includes('@amservices.eu');

  // Initialisation et récupération globale
  useEffect(() => {
    fetch('https://www.amservices.eu/api/get_users.php')
      .then((reponse) => {
        if (!reponse.ok) throw new Error(`Erreur HTTP : ${reponse.status}`);
        return reponse.json(); 
      })
      .then((data) => {
        setElements(data);
        
        // --- PRÉ-REMPLISSAGE PAR ID (NOUVEAU) ---
        const localUserId = localStorage.getItem('tuid');
        if (localUserId) {
          // On cherche si cet ID existe dans la liste des utilisateurs reçus
          const currentUserLocal = data.find(user => String(user.id) === String(localUserId));
          if (currentUserLocal) {
            setName(currentUserLocal.name);
            setEmail(currentUserLocal.mail || currentUserLocal.email); // S'adapte selon ton champ BDD
          }
        }
      })
      .catch((err) => setErreur(err.message));
  }, []);

  const handleSubmit = (e) => {
    e.preventDefault();
    if (!name.trim() || !email.trim()) return;
    
    const donneesJoueur = { name, email, score, type: estInterne ? "@amservices.eu" : "Standard" };

    fetch('https://www.amservices.eu/api/add_user.php', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify(donneesJoueur)
    })
      .then((reponse) => {
        if (!reponse.ok) throw new Error("Impossible d'enregistrer le score");
        return reponse.json();
      })
      .then((reponseData) => {
        // --- SAUVEGARDE DE L'ID EN LOCAL (NOUVEAU) ---
        if (reponseData.userId) {
          localStorage.setItem('tuid', reponseData.userId);
        }
        return fetch('https://www.amservices.eu/api/get_users.php');
      })
      .then((reponseFresh) => {
        if (!reponseFresh.ok) throw new Error("Erreur lors du rafraîchissement");
        return reponseFresh.json();
      })
      .then((NewDatas) => {
        setElements(NewDatas);
        setSubmitted(true);
      })
      .catch((err) => {
        alert("Erreur lors de l'enregistrement : " + err.message);
      });
  };

  if (erreur) return <p style={{ color: '#ff3b3b', padding: '20px', textAlign: 'center', fontWeight: 'bold' }}>Erreur : {erreur}</p>;

  const joueursGeneraux = elements.filter(p => p.type !== "@amservices.eu");
  const techniciensAM = elements.filter(p => p.type === "@amservices.eu");

  return (
    <div className="leaderboard-container">
      {/* Zone Héros */}
      <div className="death-zone-premium">
        <div className="avatar-glow-effect">
          <img src="/assets/hero_death.png" alt="Informaticien KO" className="hero-death-img-huge" />
        </div>
        <h2 className="crash-title-modern">💥 CHUTE DU TECHNICIEN !</h2>
        <div className="final-score-badge">
          SCORE FINAL : <span>{score ? Number(score).toLocaleString() : 0} PTS</span>
        </div>
      </div>

      {/* Grille principale */}
      <div className="leaderboard-content">
        
        {/* Section Gauche : Formulaire */}
        <div className="action-section">
          {!submitted ? (
            <form onSubmit={handleSubmit} className="score-form-premium">
              <h3 className="form-main-title">
                <svg viewBox="0 0 24 24" className="svg-title-icon">
                  <path d="M16 21v-2a4 4 0 0 0-4-4H6a4 4 0 0 0-4 4v2M9 11a4 4 0 1 0 0-8 4 4 0 0 0 0 8zm13-1h-6m3-3v6" fill="none" stroke="currentColor" strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round"/>
                </svg>
                Participez au tirage au sort !
              </h3>
              <p className="form-subtitle">Enregistrez votre score pour tenter de gagner le lot de la semaine.</p>
              
              <div className="form-attention-box">
                <svg viewBox="0 0 24 24" className="svg-alert-icon">
                  <path d="M10.29 3.86L1.82 18a2 2 0 0 0 1.71 3h16.94a2 2 0 0 0 1.71-3L13.71 3.86a2 2 0 0 0-3.42 0zM12 9v4m0 4h.01" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
                </svg>
                <span>Attention à bien rentrer votre adresse mail sans fautes pour  être sûr(e) de recevoir votre lot ! </span>
              </div>

              <div className="input-group-premium">
                <input 
                  type="text" 
                  placeholder="Pseudo" 
                  value={name} 
                  onChange={(e) => setName(e.target.value)}
                  required
                />
                <input 
                  type="email" 
                  placeholder="Adresse email" 
                  value={email} 
                  onChange={(e) => setEmail(e.target.value)}
                  required
                />
                <button type="submit" className="btn-submit-premium">Enregistrer mon exploit</button>
              </div>
            </form>
          ) : (
            <div className="success-card-premium">
              <div className="success-icon-wrap">🎉</div>
              <h4>Félicitations !</h4>
              <p>Votre score a été envoyé sur le serveur. Restez attentif au tirage au sort !</p>
            </div>
          )}
          
          <div className="navigation-buttons-vertical">
            <button onClick={onRestart} className="btn-replay-premium">
              <span>REJOUER UNE PARTIE</span>
              <svg viewBox="0 0 24 24" className="svg-nav-icon"><path d="M21.5 2v6h-6M21.34 15.57a10 10 0 1 1-.57-8.38l6.07-5.19" fill="none" stroke="currentColor" strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round"/></svg>
            </button>
            <button onClick={onGoHome} className="btn-home-premium">
              <span>REVOIR LES RÈGLES</span>
              <svg viewBox="0 0 24 24" className="svg-nav-icon"><path d="M3 9l9-7 9 7v11a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2zM9 22V12h6v10" fill="none" stroke="currentColor" strokeWidth="2-5" strokeLinecap="round" strokeLinejoin="round"/></svg>
            </button>
          </div>
        </div>

        {/* Section Droite : Les classements */}
        <div className="scoreboard-list gap-between-tables">
          <div className="table-wrapper">
            <h3 className="scoreboard-main-title">
              <svg viewBox="0 0 24 24" className="svg-title-icon trophy-gold">
                <path d="M6 9H4.5a2.5 2.5 0 0 1 0-5H6M18 9h1.5a2.5 2.5 0 0 0 0-5H18M4 22h16M10 14.66V17c0 .55-.45 1-1 1H4v2h16v-2h-5c-.55 0-1-.45-1-1v-2.34" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
                <path d="M12 2a6 6 0 0 1 6 6v5a6 6 0 0 1-6 6 6 6 0 0 1-6-6V8a6 6 0 0 1 6-6Z" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
              </svg>
              TOP 5 DES MEILLEURS TECHNICIENS
            </h3>
            <div className="leaderboard-table-premium">
              {!joueursGeneraux.length ? (
                <div className="leaderboard-empty-premium">
                  <p>Aucun gagnant... Jouez et tentez votre chance !</p>
                </div>
              ) : (
                joueursGeneraux.slice(0, 5).map((player, index) => (
                  <div 
                    key={player.id || index} 
                    className={`leaderboard-card-row ${String(player.id) === localStorage.getItem('tuid') ? 'current-player-row' : ''} rank-${index + 1}`}
                  >
                    <div className="rank-badge-wrap">
                      <span className="player-rank-badge">#{index + 1}</span>
                    </div>
                    <span className="player-name-text">{player.name}</span>
                    <span className="player-score-digital">
                      {player.score ? Number(player.score).toLocaleString() : 0} <small>pts</small>
                    </span>
                  </div>
                ))
              )}
            </div>
          </div>

          <div className="table-wrapper">
            <h3 className="scoreboard-main-title lime-title">
              <svg viewBox="0 0 24 24" className="svg-title-icon trophy-lime">
                <path d="M12 22s8-4 8-10V5l-8-3-8 3v7c0 6 8 10 8 10z" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
              </svg>
              LES TECHNICIENS AM SERVICES
            </h3>
            <div className="leaderboard-table-premium">
              {!techniciensAM.length ? (
                <div className="leaderboard-empty-premium">
                  <p>Aucun technicien n'a encore enregistré son score.</p>
                </div>
              ) : (
                techniciensAM.slice(0, 5).map((player, index) => (
                  <div 
                    key={player.id || index} 
                    className={`leaderboard-card-row ${String(player.id) === localStorage.getItem('tuid') ? 'current-player-row' : ''} staff-rank`}
                  >
                    <div className="rank-badge-wrap">
                      <span className="player-rank-badge staff">#{index + 1}</span>
                    </div>
                    <span className="player-name-text">{player.name}</span>
                    <span className="player-score-digital">
                      {player.score ? Number(player.score).toLocaleString() : 0} <small>pts</small>
                    </span>
                  </div>
                ))
              )}
            </div>
          </div>
        </div>

      </div>
    </div>
  );
};

export default Leaderboard;